
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
        <mat-form-field>
          <mat-select placeholder={{fieldName}} (selectionChange)="changedvalue($event.value)" [value]="selectedLocation" >
            <mat-option *ngFor="let loc of content" [value]="loc" >{{loc}}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button  (click)="save()">OK</button>
      </mat-dialog-actions>
    </form>
  